/**
 * This is here for backwards compatibility with 4.2
 */
export { FluentMaterial } from "./fluent/fluentMaterial";
